import React from 'react';
import { Articles, Features, Footer, Header, Navbar } from '../../components';

const Homepage = () => {
  return (
    <>
      <Navbar />
      <Header />
      <Articles />
      <Features />
      <Footer />
    </>
  )
}

export default Homepage